import users_api from "../../api/users";
import {useEffect, useState} from "react";
import dateUtils from "../../utils/DateUtils";
import GenericDialog from "../../components/GenericDialog";
import { useNavigate, useSearchParams } from "react-router-dom";
import subscriptionUtils from "../../utils/SubscriptionUtils";
import textUtils from "../../utils/TextUtils";
import AccessCodesTable from "../../components/AccessCodesTable";
import auth from "../../api/auth";

const AccessCodes = () => {

    const navigate = useNavigate()

    // Error Dialog
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogText, setDialogText] = useState("")
    const buttons = [{"text":"OK", "id": "1"}];
    const [searchParams] = useSearchParams();
    const tableType = searchParams.get("table") || "usable"; // default usable

    useEffect(() => {
        auth.hasSession().then((session) => {
            if (!session) window.location.assign("/logout");
        });
    }, [])

    const handleErrorDialogResult = (res) => {
        if(!res) return;
        setDialogText("")
        setDialogTitle("")
    }

    return (
        <div className="page-container">
            <div className="page-title">
                Access Codes
            </div>
            <div className="insert-new button link" onClick={() => navigate("/access-codes/new")}>
                Insert New Access Code
            </div>
            {dialogText && dialogText ? <GenericDialog title={dialogTitle} text={dialogText} buttons={buttons}
                                             result={handleErrorDialogResult.bind(this)}/> : null}
            {tableType === "usable" && (
                <AccessCodesTable subtitle="Usable Access Codes" type="usable" setDialogTitle={setDialogTitle}
                                  setDialogText={setDialogText} showDelete={true} showName={false} showEmail={false}/>
            )}
            {tableType === "expired" && (
                <AccessCodesTable subtitle="Expired Access Codes" type="expired" setDialogTitle={setDialogTitle}
                                  setDialogText={setDialogText} showDelete={true} showName={false} showEmail={false}/>
            )}
            {tableType === "used" && (
                <AccessCodesTable subtitle="Used Access Codes" type="used" setDialogTitle={setDialogTitle}
                                  setDialogText={setDialogText} showDelete={false} showName={true} showEmail={true}/>
            )}
        </div>
    )
}

export default AccessCodes